module.exports = __webpack_public_path__ + "static/media/SBT23concept.a4d1f1f9.jpg";